import React from "react";
//import { makeStyles } from "@material-ui/core/styles";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
} from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Config from "conFig.js";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
//import styles from "assets/jss/material-dashboard-react/components/tableviewStyle.js";
//const useStyles = makeStyles(styles);
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
const vpcolumn = [
  {
    field: "dvkdvt",
    headerName: "Đơn vị",
    width: 220,
    headerAlign: "center",
  },
  {
    field: "sodangky",
    headerName: "Số đăng ký",
    width: 160,
    headerAlign: "center",
  },
];
const vpctcolumn = [
  {
    field: "stt",
    headerName: "STT",
    width: 70,
    headerAlign: "center",
  },
  {
    field: "sodangky",
    headerName: "Số đăng ký",
    width: 130,
    headerAlign: "center",
  },
  {
    field: "sohopdong",
    headerName: "Số hợp đồng",
    width: 140,
    headerAlign: "center",
  },
  {
    field: "ngayhopdong",
    headerName: "Ngày hợp đồng",
    width: 150,
    headerAlign: "center",
    valueFormatter: (params) => dayjs(params.value).format("DD/MM/YYYY"),
  },
  {
    field: "diadiem_dau",
    headerName: "Điểm đầu",
    width: 220,
    headerAlign: "center",
  },
  {
    field: "diadiem_cuoi",
    headerName: "Điểm cuối",
    width: 220,
    headerAlign: "center",
  },
  {
    field: "diemdontrakhach",
    headerName: "Điểm đón trả khách",
    width: 200,
    headerAlign: "center",
  },
  {
    field: "hanhtrinh",
    headerName: "Hành trình",
    width: 200,
    headerAlign: "center",
  },
];

export default function Canhbaoxehopdong() {
  //const classes = useStyles();
  const [pageSize, setPageSize] = React.useState(50);
  const [ngaythang, setNgaythang] = React.useState(dayjs());
  const [vipham, setVipham] = React.useState([]);
  const [viphamct, setViphamct] = React.useState([]);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
      </Box>
    );
  };
  const checkviphamhdvtthang = (thangnambc) => {
    var thang =
      String(thangnambc.$M + 1).padStart(2, "0") + "/" + thangnambc.$y;
    var url =
      Config.backend +
      "/api/ViPham/checkviphamhdvtthang?thang=" +
      thang +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setVipham(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const getviphamtheosodangky = (sodangky) => {
    var thang = String(ngaythang.$M + 1).padStart(2, "0") + "/" + ngaythang.$y;
    var url =
      Config.backend +
      "/api/ViPham/getviphamhdvtthangpt?thang=" +
      thang +
      "&sodangky=" +
      sodangky +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setViphamct(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  React.useEffect(() => {
    checkviphamhdvtthang(ngaythang);
  }, []);

  return (
    <GridContainer>
      <GridItem xs={12} sm={10} md={2} style={{ marginTop: 5 }}>
        <FormControl style={{ width: "100%", marginTop: 3 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Tháng vi phạm"
              value={ngaythang}
              format="MM/YYYY"
              onChange={(newValue) => {
                setNgaythang(newValue);
                setViphamct([]);
                checkviphamhdvtthang(newValue);
              }}
              slotProps={{ textField: { size: "small" } }}
              views={["month", "year"]}
              sx={{
                "& .MuiInputBase-root": {
                  height: "27px",
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={10} md={9} style={{ marginTop: 5 }}></GridItem>
      <GridItem xs={12} sm={10} md={4} style={{ marginTop: 10 }}>
        <div style={{ height: 500, width: "100%" }}>
          <DataGrid
            getRowId={(row) => row.id}
            rows={vipham}
            columns={vpcolumn}
            checkboxSelection={false}
            getRowHeight={() => "auto"}
            headerHeight={35}
            onRowClick={(params) => {
              getviphamtheosodangky(params.row.sodangky);
            }}
            hideFooter
            sx={datagridSx}
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: quickSearchToolbar }}
          />
        </div>
      </GridItem>
      <GridItem xs={12} sm={10} md={8} style={{ marginTop: 10 }}>
        <div style={{ height: 500, width: "100%" }}>
          <DataGrid
            getRowId={(row) => row.id}
            rows={viphamct}
            columns={vpctcolumn}
            checkboxSelection={false}
            getRowHeight={() => "auto"}
            headerHeight={35}
            sx={datagridSx}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: quickSearchToolbar }}
          />
        </div>
      </GridItem>
    </GridContainer>
  );
}
